import React, { useEffect, useState } from "react"
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { UFDate } from "../../../components/Common/Fields/Input"
import moment from "moment"
import { isEmpty } from "lodash"
import { useForm } from "react-hook-form"
import {
  downloadBalanceSheet,
  fetchFinanceBalanceSheet,
} from "../../../services/finance/finance"
import UpdateTable from "../../../components/Common/UpdatedTable"
import NumberFormat from "../../../utils/numberFormat"
import arrow from "../../../assets/icons/arrow.svg"
import { useLocation, useNavigate } from "react-router-dom"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import BalanceSheetAccordion from "./customAccordion"
import resetIcon from "../../../assets/icons/reset.svg"
import { setFilter, removeFilter } from "../../../store/actions"
import WordSymbolDisplay from "../../../components/Common/LoadingAnim"

const BalanceSheet = ({ fromDashboard }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Balance Sheet${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`
  const dispatch = useDispatch()
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""
  const [refresh, setRefresh] = useState(0)
  const [isLoading, setIsLoading] = useState(true)

  const [rSelected, setRSelected] = useState(1)

  const [accordionOpen, setAccordionOpen] = useState("")

  const [openMap, setOpenMap] = useState({})

  const [detailedCheckIds, setDetailedCheckIds] = useState([])

  // handler receives (sourceKey, openIdsArray)
  // NestedAccordion will call this as (parentKey, openArray)
  const handleOpenChange = (sourceKey, openIdsArray) => {
    console.log(`openIdsArray`, openIdsArray)

    // store the array under the sourceKey so we can aggregate later
    setOpenMap(prev => ({ ...prev, [sourceKey]: openIdsArray || [] }))
  }

  const getAllGroupIds = data => {
    const ids = []

    const extractIds = arr => {
      arr?.forEach(item => {
        if (item?.id) ids.push(item.id)
        if (item?.sub_groups?.length) extractIds(item.sub_groups)
      })
    }

    // Loop top-level categories like asset, liability, income, expense...
    Object.values(data).forEach(section => {
      if (Array.isArray(section)) extractIds(section)
    })

    return ids
  }

  // keep accordionOpen as a flattened unique array of open data ids
  useEffect(() => {
    const all = [...new Set(Object.values(openMap).flat())]
    setAccordionOpen(all)
  }, [openMap])

  useEffect(() => {
    if (rSelected === 2) {
      const allIds = getAllGroupIds(fetchedData?.data)
      console.log("allIds", allIds)
      setDetailedCheckIds(allIds)
    } else {
      setDetailedCheckIds([])
    }
  }, [rSelected])

  console.log(`detailedCheckIds`, detailedCheckIds)

  const { control, watch, reset, setValue } = useForm()

  const navigate = useNavigate()

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      if (filters?.dateFrom || filters?.dateTo) {
        setValue(
          "start_date",
          filters?.dateFrom
            ? moment(filters?.dateFrom, "YYYY-MM-DD").toDate()
            : null,
          { shouldValidate: false, shouldDirty: false }
        )
        setValue(
          "end_date",
          filters?.dateTo
            ? moment(filters?.dateTo, "YYYY-MM-DD").toDate()
            : null,
          { shouldValidate: false, shouldDirty: false }
        )
        const responce = await fetchFinanceBalanceSheet({
          params: `${
            filters?.dateFrom ? `&start_date=${filters?.dateFrom}` : ""
          }${`&sortOrder=asc`}${
            filters?.dateTo ? `&end_date=${filters?.dateTo}` : ""
          }`,
        })

        setFetchedData(responce)
        setIsLoading(false)
      }
    }
    fetchData()
  }, [filters?.dateFrom, filters?.dateTo])

  useEffect(() => {
    if (filters?.dateFrom || filters?.dateTo) return
    const fetchData = async () => {
      setIsLoading(true)
      const responce = await fetchFinanceBalanceSheet({
        params: `${
          startDate ? `&start_date=${startDate}` : ""
        }${`&sortOrder=asc`}${endDate ? `&end_date=${endDate}` : ""}`,
      })

      setFetchedData(responce)
      setIsLoading(false)
    }
    fetchData()
  }, [startDate, endDate])

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    setStartDate(fromDate)
    setEndDate(toDate)
  }

  const assetColumns = [
    {
      label: "Group Name",
      renderCell: item => item?.group_name,
    },
    {
      label: <div className="text-end pe-5">Amount</div>,
      renderCell: item => (
        <div className={`${Number(item?.balance) > 0 ? "" : ""} text-end pe-5`}>
          {NumberFormat(
            Math.abs(
              Number(item?.credit) > Number(item?.debit)
                ? Number(item?.credit) - Number(item?.debit)
                : Number(item?.debit) - Number(item?.credit)
            ),
            desimalrange,
            desimalrange
          )}{" "}
          {/* {Number(item?.credit) != 0 ? "Cr" : "Dr"} */}
          {/* {item?.balance
            ? NumberFormat(Math.abs(Number(item?.balance)), 3, 3)
            : 0.0}{" "}
          {Number(item?.balance) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
  ]
  const liabilityColumns = [
    {
      label: "Group Name",
      renderCell: item => item?.group_name,
    },
    {
      label: <div className="text-end pe-5">Amount</div>,
      renderCell: item => (
        <div className={`${Number(item?.balance) < 0 ? "" : ""} text-end pe-5`}>
          {NumberFormat(
            Math.abs(
              Number(item?.credit) > Number(item?.debit)
                ? Number(item?.credit) - Number(item?.debit)
                : Number(item?.debit) - Number(item?.credit)
            ),
            desimalrange,
            desimalrange
          )}{" "}
          {/* {Number(item?.credit) != 0 ? "Cr" : "Dr"} */}
          {/* {item?.balance
            ? NumberFormat(Math.abs(Number(item?.balance)), 3, 3)
            : 0.0}{" "}
          {Number(item?.balance) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
  ]
  const equityColumns = [
    {
      label: "Group Name",
      renderCell: item => item?.group_name,
    },
    {
      label: <div className="text-end pe-5">Amount</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.balance), desimalrange, desimalrange)}
        </div>
      ),
    },
  ]
  const assetSubColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance-ledger-acc`, {
              state: { item, startDate, endDate },
            })
          }
          className="pointer fw-bold ps-3"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit</div>,
      renderCell: item => (
        <div
          className={`${
            item?.balance_type == "credit" ? "" : ""
          } text-end pe-5`}
        >
          {NumberFormat(
            Math.abs(
              Number(item?.credit) > Number(item?.debit)
                ? Number(item?.credit) - Number(item?.debit)
                : Number(item?.debit) - Number(item?.credit)
            ),
            desimalrange,
            desimalrange
          )}{" "}
          {/* {Number(item?.credit) != 0 ? "Cr" : "Dr"} */}
          {/* {NumberFormat(
            Math.abs(Number(item?.balance ? item?.balance : 0)),
            3,
            3
          )}{" "}
          {Number(item?.balance) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
    // {
    //   label: <div className="text-end pe-5">Debit</div>,
    //   renderCell: item => <div className="text-end pe-5">{NumberFormat((Number(item?.debit_sum ? item?.debit_sum : 0)), 3, 3)}</div>,
    // },
  ]
  const liabilitySubColumns = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance-ledger-acc`, {
              state: { item, startDate, endDate },
            })
          }
          className="pointer fw-bold ps-3"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit</div>,
      renderCell: item => (
        <div
          className={`${
            item?.balance_type == "credit" ? "" : ""
          } text-end pe-5`}
        >
          {NumberFormat(
            Math.abs(
              Number(item?.credit) > Number(item?.debit)
                ? Number(item?.credit) - Number(item?.debit)
                : Number(item?.debit) - Number(item?.credit)
            ),
            desimalrange,
            desimalrange
          )}{" "}
          {/* {Number(item?.credit) != 0 ? "Cr" : "Dr"} */}
          {/* {NumberFormat(
            Math.abs(Number(item?.balance ? item?.balance : 0)),
            3,
            3
          )}{" "}
          {Number(item?.balance) > 0 ? "Cr" : "Dr"} */}
        </div>
      ),
    },
    // {
    //   label: <div className="text-end pe-5">Debit</div>,
    //   renderCell: item => <div className="text-end pe-5">{NumberFormat((Number(item?.debit_sum ? item?.debit_sum : 0)), 3, 3)}</div>,
    // },
  ]
  const equitySubColumns = [
    {
      label: "Group Name",
      renderCell: item => item?.name,
    },
    {
      label: <div className="text-end pe-5">Credit</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.credit_sum ? item?.credit_sum : 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Debit</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.debit_sum ? item?.debit_sum : 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
  ]

  const reduceBalance = (assets, amount) => {
    // Reduce the balance of each asset and sum them up
    const total = assets?.reduce((sum, asset) => {
      return sum + (asset.balance - amount) // Reduce the balance and accumulate
    }, 0)

    return total // Return the total balance after reduction
  }

  const handleReset = () => {
    reset()
    setStartDate("")
    setEndDate("")
    setRefresh(refresh + 1)
    dispatch(removeFilter())
  }

  return (
    <React.Fragment>
      <div className={`page-content tnt-scope ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: crumb || "Reports", link: "#" },
                    { title: "Balance Sheet", link: "/finance-balance-sheet" },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            <>
              {fetchedData?.data ? (
                <>
                  <ButtonGroup className="mb-auto">
                    <Button
                      color="primary px-2 m-0"
                      outline
                      onClick={() => {
                        setRSelected(1)
                        // setAgeingPeriod([])
                      }}
                      active={rSelected === 1}
                    >
                      Default
                    </Button>
                    <Button
                      color="primary px-2 m-0"
                      outline
                      onClick={() => {
                        // setAgeingPeriod([])
                        setRSelected(2)
                      }}
                      active={rSelected === 2}
                    >
                      Detailed
                    </Button>
                  </ButtonGroup>
                </>
              ) : (
                <></>
              )}
              <div className="me-2">
                <span
                  id={`PopoverLegacy-1`}
                  className="px-2 mb-3 btn btn-primary"
                >
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadBalanceSheet({
                        params: `pdf=true${
                          startDate ? `&start_date=${startDate}` : ""
                        }${endDate ? `&end_date=${endDate}` : ""}${
                          rSelected === 2
                            ? `&show_paths=${detailedCheckIds}`
                            : accordionOpen?.length
                            ? `&show_paths=${accordionOpen}`
                            : ""
                        }`,
                        type: "pdf",
                        fileName: "balance_sheet.pdf",
                      })
                    }
                  >
                    PDF
                  </div>

                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadBalanceSheet({
                        params: `excel=true${
                          startDate ? `&start_date=${startDate}` : ""
                        }${endDate ? `&end_date=${endDate}` : ""}${
                          rSelected === 2
                            ? `&show_paths=${detailedCheckIds}`
                            : accordionOpen?.length
                            ? `&show_paths=${accordionOpen}`
                            : ""
                        }`,
                        type: "excel",
                        fileName: "balance_sheet.xlsx",
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            <div className="d-flex justify-content-between align-items-center my-2 me-2">
              <div className="filter-wrapper-balance"></div>
              <div className="pe-2 d-flex align-items-center">
                <div
                  className="export-div pointer reset-img me-2 py-2"
                  onClick={() => handleReset()}
                >
                  <img src={resetIcon} height={15} width={15} className="" />{" "}
                </div>
                {/* Start Date */}
                <div className="me-2">
                  <UFDate
                    control={control}
                    name="start_date"
                    placeholder="Start Date"
                    mode="single"
                    onDateChange={([date]) =>
                      setStartDate(
                        date ? moment(date).format("YYYY-MM-DD") : ""
                      )
                    }
                    maxDate={endDate || undefined}
                    readOnly={false}
                    widthClass="w-100"
                  />
                </div>
                {/* End Date */}
                <div>
                  <UFDate
                    control={control}
                    name="end_date"
                    placeholder="End Date"
                    mode="single"
                    onDateChange={([date]) =>
                      setEndDate(date ? moment(date).format("YYYY-MM-DD") : "")
                    }
                    minDate={startDate || undefined}
                    readOnly={false}
                    widthClass="w-100"
                  />
                </div>
              </div>
            </div>
            <hr className="table-divide" />
            {isLoading ? (
              <WordSymbolDisplay />
            ) : (
              <>
                <div className="d-flex justify-content-center">
                  <div className="purchase-view-div-report">
                    <div className="payroll-total d-flex justify-content-center mb-2 edittheamtitle">
                      Balance Sheet
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                      {startDate && endDate
                        ? `${moment(startDate).format("DD-MMM-YYYY")} -
                    ${moment(endDate).format("DD-MMM-YYYY")}`
                        : `As of ${moment().format("DD-MMM-YYYY")}`}
                    </div>
                    <hr className="table-divide" />

                    <div className="ps-4 py-3 dotted-border-y">
                      <div className="d-flex justify-content-between">
                        <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                          Assets
                        </div>
                        <div
                          className={`${
                            Number(reduceBalance(fetchedData?.data?.asset, 0)) >
                            0
                              ? ""
                              : ""
                          } mapping-setup-title py-2`}
                        >
                          {fetchedData?.data?.asset &&
                            NumberFormat(
                              Math.abs(
                                Number(
                                  reduceBalance(fetchedData?.data?.asset, 0)
                                )
                              ),
                              desimalrange,
                              desimalrange
                            )}{" "}
                          AED
                        </div>
                      </div>
                      <div className="ms-3">
                        <Row className="mt-2 ever-rise-table reportTableBalance trial-table">
                          <Col xs={12}>
                            {fetchedData?.data?.asset && (
                              <BalanceSheetAccordion
                                data={fetchedData?.data?.asset}
                                startDate={startDate}
                                endDate={endDate}
                                menuLabell="Balance Sheet"
                                parentKey="asset"
                                onOpenChange={handleOpenChange}
                                forceOpenAll={rSelected === 2}
                              />
                            )}
                          </Col>
                        </Row>
                        {/* {fetchedData?.data?.asset && (
                      <div className="d-flex justify-content-between total-amount-div px-4">
                        <div className="text-capitalize py-2">Total</div>
                        <div className="py-2">
                          {fetchedData?.data?.asset &&
                            reduceBalance(fetchedData?.data?.asset, 0)}{" "}
                          AED
                        </div>
                      </div>
                    )} */}
                      </div>

                      {/* {fetchedData?.data?.asset?.map((dt, i) => {
                  const totalDifference = fetchedData?.data?.asset?.reduce(
                    (total, entry) => {
                      return (
                        total +
                        entry.accounts.reduce((accountTotal, account) => {
                          const credit = parseFloat(account.credit_sum)
                          const debit = parseFloat(account.debit_sum)
                          return accountTotal + (credit - debit)
                        }, 0)
                      )
                    },
                    0
                  )

                  return (
                    <div key={`name_${i}`}>
                      <div className="bal-sub-title py-2 text-capitalize">
                        {dt?.name}
                      </div>
                      <table className="estimation-table">
                        <tbody>
                          {dt?.accounts?.map((itm, j) => (
                            <tr key={`tbl_${j}`} className="py-2">
                              <td className="ps-5 text-capitalize">
                                {itm?.account_name}
                              </td>
                              <td>
                                {Number(itm?.credit_sum || 0) -
                                  Number(itm?.debit_sum || 0)}{" "}
                                AED
                              </td>
                            </tr>
                          ))}
                          <tr className="total-amount-div px-3">
                            <td sm={6} className="text-capitalize">
                              Total {dt?.name}
                            </td>
                            <td sm={6}>{totalDifference} AED</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )
                })} */}
                    </div>
                    <div className="ps-4 py-3 dotted-border-y">
                      <div className="d-flex justify-content-between">
                        <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                          Liability
                        </div>
                        <div
                          className={`${
                            Number(reduceBalance(fetchedData?.data?.asset, 0)) >
                            0
                              ? ""
                              : ""
                          } mapping-setup-title py-2`}
                        >
                          {fetchedData?.data?.liability &&
                            NumberFormat(
                              Math.abs(
                                Number(
                                  reduceBalance(fetchedData?.data?.liability, 0)
                                )
                              ),
                              desimalrange,
                              desimalrange
                            )}{" "}
                          AED
                        </div>
                      </div>
                      <div className="ms-3">
                        <Row className="mt-2 ever-rise-table reportTableBalance trial-table ">
                          <Col xs={12}>
                            {fetchedData?.data?.liability && (
                              // <UpdateTable
                              //   // className="mt-5"
                              //   nodes={fetchedData?.data?.liability}
                              //   columns={liabilityColumns}
                              //   subColumn={liabilitySubColumns}
                              //   handilpagedrop={false}
                              //   subName={"ledgers"}
                              //   // subHeader={true}
                              //   tableWidth="50% 50%"
                              //   mobileWidth="50% 50%"
                              //   expand={true}
                              //   headerHide={true}
                              // />
                              <BalanceSheetAccordion
                                data={fetchedData?.data?.liability}
                                startDate={startDate}
                                endDate={endDate}
                                menuLabell="Balance Sheet"
                                parentKey="liablility"
                                onOpenChange={handleOpenChange}
                                forceOpenAll={rSelected === 2}
                              />
                            )}
                          </Col>
                        </Row>
                        {/* {fetchedData?.data?.liability && (
                      <div className="d-flex justify-content-between total-amount-div px-4">
                        <div className="text-capitalize py-2">Total</div>
                        <div className="py-2">
                          {fetchedData?.data?.liability &&
                            reduceBalance(fetchedData?.data?.liability, 0)}{" "}
                          AED
                        </div>
                      </div>
                    )} */}
                      </div>
                    </div>
                    {/* <div className="ps-4 py-3 dotted-border-y">
                  <div className="mapping-setup-title py-2 text-capitalize">
                    Equity
                  </div>
                  <div className="ms-3">
                    <Row className="mt-2 ever-rise-table moduleTable ">
                      <Col xs={12}>
                        {fetchedData?.data?.equity && (
                          <UpdateTable
                            // className="mt-5"
                            nodes={fetchedData?.data?.equity}
                            columns={equityColumns}
                            subColumn={equitySubColumns}
                            subName={"details"}
                            subHeader={true}
                            tableWidth="50% 50%"
                            expand={true}
                          />
                        )}
                      </Col>
                    </Row>
                    {fetchedData?.data?.equity && (
                      <div className="d-flex justify-content-between total-amount-div px-4">
                        <div className="text-capitalize py-2">Total</div>
                        <div className="py-2">
                          {fetchedData?.data?.equity &&
                            reduceBalance(fetchedData?.data?.equity, 0)}{" "}
                          AED
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}
                    {/* <div className="ps-4 py-3 dotted-border-y">
                <div className="mapping-setup-title py-2 text-capitalize">
                  Equity
                </div>
                {fetchedData?.data?.equity?.map((dt, i) => {
                  const totalDifference = fetchedData?.data?.equity?.reduce(
                    (total, entry) => {
                      return (
                        total +
                        entry.accounts.reduce((accountTotal, account) => {
                          const credit = parseFloat(account.credit_sum)
                          const debit = parseFloat(account.debit_sum)
                          return accountTotal + (credit - debit)
                        }, 0)
                      )
                    },
                    0
                  )

                  return (
                    <div key={`name_${i}`}>
                      <div className="bal-sub-title py-2 text-capitalize">
                        {dt?.name}
                      </div>
                      <table className="estimation-table">
                        <tbody>
                          {dt?.accounts?.map((itm, j) => (
                            <tr key={`tbl_${j}`} className="py-2">
                              <td className="ps-5 text-capitalize">
                                {itm?.account_name}
                              </td>
                              <td>
                                {Number(itm?.credit_sum || 0) -
                                  Number(itm?.debit_sum || 0)}{" "}
                                AED
                              </td>
                            </tr>
                          ))}
                          <tr className="total-amount-div px-3">
                            <td sm={6} className="text-capitalize">
                              Total {dt?.name}
                            </td>
                            <td sm={6}>{totalDifference} AED</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )
                })}
              </div>
              <div className="ps-4 py-3 dotted-border-y">
                <div className="mapping-setup-title py-2 text-capitalize">
                  Liability
                </div>
                {fetchedData?.data?.liability?.map((dt, i) => {
                  const totalDifference = fetchedData?.data?.liability?.reduce(
                    (total, entry) => {
                      return (
                        total +
                        entry.accounts.reduce((accountTotal, account) => {
                          const credit = parseFloat(account.credit_sum)
                          const debit = parseFloat(account.debit_sum)
                          return accountTotal + (credit - debit)
                        }, 0)
                      )
                    },
                    0
                  )

                  return (
                    <div key={`name_${i}`}>
                      <div className="bal-sub-title py-2 text-capitalize">
                        {dt?.name}
                      </div>
                      <table className="estimation-table">
                        <tbody>
                          {dt?.accounts?.map((itm, j) => (
                            <tr key={`tbl_${j}`} className="py-2">
                              <td className="ps-5 text-capitalize">
                                {itm?.account_name}
                              </td>
                              <td>
                                {Number(itm?.credit_sum || 0) -
                                  Number(itm?.debit_sum || 0)}{" "}
                                AED
                              </td>
                            </tr>
                          ))}
                          <tr className="total-amount-div px-3">
                            <td sm={6} className="text-capitalize">
                              Total {dt?.name}
                            </td>
                            <td sm={6}>{totalDifference} AED</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )
                })}
              </div> */}

                    {/* {fetchedData?.map((dt, i) => {
                // Calculate the total for each subcategory
                const subcategoryTotal = dt?.items?.reduce((acc, itm) => {
                  const creditAmount = Number(
                    itm?.journal_entry_details_sum_credit_amount || 0
                  )
                  const debitAmount = Number(
                    itm?.journal_entry_details_sum_debit_amount || 0
                  )
                  return acc + (creditAmount - debitAmount)
                }, 0)

                return (
                  <div key={i} className="ps-4 py-3">
                    <div className="mapping-setup-title py-2 text-capitalize">
                      {dt?.items[0]?.category?.name}
                    </div>
                    <div className="bal-sub-title py-2 text-capitalize">
                      {dt?.items[0]?.subcategory?.name}
                    </div>
                    <table className="estimation-table">
                      <tbody>
                        {dt?.items?.map((itm, i) => (
                          <tr key={i} className="py-2">
                            <td className="ps-5 text-capitalize">
                              {itm?.name}
                            </td>
                            <td>
                              {Number(
                                itm?.journal_entry_details_sum_credit_amount ||
                                  0
                              ) -
                                Number(
                                  itm?.journal_entry_details_sum_debit_amount ||
                                    0
                                )}{" "}
                              AED
                            </td>
                          </tr>
                        ))}
                        <tr className="total-amount-div px-3">
                          <td sm={6} className="text-capitalize">
                            Total {dt?.items[0]?.subcategory?.name}
                          </td>
                          <td sm={6}>{subcategoryTotal} AED</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )
              })} */}
                  </div>
                </div>
              </>
            )}
            {/* {fetchedData?.map((dt, i) => (
              <div>
                <div>{dt?.items[0]?.category?.name}</div>
                <div>{dt?.items[0]?.subcategory?.name}</div>
                {dt?.items?.map((itm, i) => (
                  <div>
                    <div>{itm?.name}</div>
                    <div>
                      {Number(
                        itm?.journal_entry_details_sum_credit_amount
                          ? itm?.journal_entry_details_sum_credit_amount
                          : 0
                      ) -
                        Number(
                          itm?.journal_entry_details_sum_debit_amount
                            ? itm?.journal_entry_details_sum_debit_amount
                            : 0
                        )}
                    </div>
                  </div>
                ))}
                <div>
                    <div>Total {dt?.items[0]?.subcategory?.name}</div>
                    <div></div>
                </div>
              </div>
            ))} */}
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default BalanceSheet
